import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { CaseListingInstanceState } from 'app/area/case-report/case-listing/types-store';

export interface EnabledEntityOperations {
  edit: boolean;
  delete: boolean;
  bowtie: boolean;
  surveyManager: boolean;
}

export const casePermissions =
  (state: CaseState | CaseListingInstanceState, uiEngineProps: ConnectedComponentProps):
    { enabledEntityOperations: EnabledEntityOperations; permissionsLoaded:boolean } => {
    const { tblTrans: entityId } = uiEngineProps.resolveContext.path[0];

    let permissions;

//TODO: Ideally these states would both store the permissions in a way that can be accessed the same way.
    if ((state as CaseListingInstanceState).results) {
      const relevantCase = (state as CaseListingInstanceState).results.find(r => r.entityId === entityId);
      permissions = relevantCase && state.permissions && state.permissions[relevantCase.caseNumber];
    } else {
      permissions = (state as CaseState).permissions;
    }

    return {
      enabledEntityOperations: permissions ? {
        edit: permissions.edit as boolean,
        delete: permissions.delete as boolean,
        bowtie: permissions.bowtie as boolean,
        surveyManager: permissions.surveyManager as boolean
      } :
      { edit: false, delete: false, bowtie: false, surveyManager: false },
      permissionsLoaded: !!permissions
    };
  };
